import React from 'react';
import { Image, Header, Text } from '@gasbuddy/react-components';
import { Banner } from '../Banner';

import style from './InlineBanners.module.css';

export default function ReviewCTABanner() {
  return (
    <Banner className={style.bannerOverrideReviewCTA} backgroundImage="https://static.gasbuddy.com/web/consumer/reviews-bg.png">
      <div className={style.reviewCtaContent}>
        <Header as="h2" className={style.reviewHeader}>
          Want to write a review?
          <Text className={style.reviewSubHeader}>
            Download the GasBuddy App
          </Text>
        </Header>
        <div className={style.imageGroupContainer}>
          <a href="https://apps.apple.com/us/app/gasbuddy-find-cheap-gas-prices/id406719683?mt=8">
            <Image
              className={style.storeBadge}
              src="/assets-v2/svg/cta/apple-store-badge.svg"
              alt="Apple Store Badge Button"
            />
          </a>
          <a href="https://play.google.com/store/apps/details?id=gbis.gbandroid">
            <Image
              className={style.storeBadge}
              src="/assets-v2/svg/cta/play-store-badge.svg"
              alt="Google Play Store Badge Button"
            />
          </a>
        </div>
      </div>
    </Banner>
  );
}
